<template>
  <affix
    relative-element-selector="#home-section"
    :vertical="true"
    :offset="{ top: 106, bottom: 0, padding: 0 }"
    style="background:white"
    class="light-shadow"
    id="searchNavBar"
  >
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-4 d-none d-sm-block"></div>
        <div class="col-lg-5 col-md-8 mx-auto">
          <fg-input
            class="no-border add-margin-top-10"
            :placeholder="$t('input.placeholder.search')"
            v-model="searchTerm"
            addon-right-icon="now-ui-icons ui-1_zoom-bold"
            @input="searchByTerm($event)"
          >
          </fg-input>
        </div>
        <div class="col-lg-4 d-none d-lg-block"></div>
      </div>
    </div>
  </affix>
</template>

<script>
import {
  Affix,
  Button,
  FormGroupInput
} from "@/components";
import { mapState } from "vuex";
import { Popover } from "element-ui";
export default {
  name: "main-navbar",
  components: {
    [Popover.name]: Popover,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    Affix
  },
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  data() {
    return {
      active: "menu",
      searchTerm: ""
    };
  },

  methods: {
    searchByTerm: function(event) {
      this.$root.$emit("SEARCH_ITEMS", event);
    },
  }
};
</script>

<style scoped>
.vue-affix {
  width: 100%;
  z-index: 997;
}
.input-group {
  margin-bottom: 0px;
}
</style>
